import { useState, useEffect } from 'react';
import MainHeader from '../home/MainHeader';
import Footer from '../Footer';
import BillboardImage from '../home/components/BillboardImage';
import { CookiesMessage } from '../footer/CookiesMessage';
import { FloatingButtonGroup } from '../ui';
import BrandingHeroStack from 'frontend/features/branding/BrandingHeroStack';
import { useBrandingProps } from 'frontend/features/branding/useBrandingProps';
import { getFooterTemplate } from 'frontend/features/branding/footer';
import ListingBrandScope from './ListingBrandScope';

const UnifiedLayout = ({
  children,
  showSearchBar = false,
  showBillboard = true,
  hideFAB = false,
  hideHeader = false,
  hideMobileNavMenu = false,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const branding = useBrandingProps();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (branding) {
    const { Component: BrandingFooter } = getFooterTemplate(branding.footerTemplateCode);
    return (
      <>
        <div className='relative min-h-screen'>
          {(!hideHeader || showBillboard) && (
            <BrandingHeroStack
              branding={branding}
              showHeader={!hideHeader}
              showHero={showBillboard}
            />
          )}
          <ListingBrandScope
            className={`relative z-10 ${!showSearchBar ? 'packages-container' : ''}`}
          >
            {children}
          </ListingBrandScope>
        </div>
        <BrandingFooter
          config={branding.footerConfig}
          contact={{
            email: branding.headerConfig.email,
            phone: branding.headerConfig.phone,
            showEmail: branding.headerConfig.showEmail,
            showPhone: branding.headerConfig.showPhone,
            socialLinks: branding.headerConfig.socialLinks,
          }}
          officeInfo={branding.footerOfficeInfo}
        />
        <CookiesMessage />
        {!hideFAB && <FloatingButtonGroup />}
      </>
    );
  }

  return (
    <>
      <div className='relative min-h-screen'>
        {!hideHeader && (
          <div
            className={`fixed top-0 left-0 right-0 z-20 transition-all duration-300 ${
              isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
            }`}
          >
            <MainHeader isScrolled={isScrolled} hideMobileNavMenu={hideMobileNavMenu} />
          </div>
        )}
        {showBillboard && (
          <div className='relative w-full'>
            <BillboardImage />
          </div>
        )}
        <div className={`relative z-10 ${!showSearchBar ? 'packages-container' : ''}`}>
          {children}
        </div>
      </div>
      <Footer />
      <CookiesMessage />
      {!hideFAB && (
        <FloatingButtonGroup />
      )}
    </>
  );
};

export default UnifiedLayout;
